import emailjs from '@emailjs/browser';
import React, { useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { FiMail, FiMapPin, FiPhone, FiSend } from 'react-icons/fi';
import '../Styles/MainStyles/Contact.css';

// Initialize EmailJS
emailjs.init("yFO8mzknugOT70Ydm");

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Set up template parameters from form data
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
      };

      // Send email through EmailJS
      await emailjs.send(
        'service_tsoicep', // EmailJS service ID
        'template_ptm1bi9', // EmailJS template ID
        templateParams,
        'yFO8mzknugOT70Ydm' // EmailJS public key
      );

      // Success handling
      setStatus('success');
      setAlertMessage("Thank you for your message! We'll get back to you soon.");
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

    } catch (error) {
      // Error handling
      console.error('Email send failed:', error);
      setStatus('danger');
      setAlertMessage('Sorry, there was a problem sending your message. Please try again later.');
    } finally {
      setIsSubmitting(false);
      
      // Hide alert after 5 seconds
      setTimeout(() => {
        setStatus(null);
      }, 5000);
    }
  };

  return (
    <section id="contact" className="py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Contact Us</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
            Have questions? Get in touch with our team
          </p>
        </div>
        
        <Row className="g-4">
          <Col lg={5} className="mb-4 mb-lg-0">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                <h4 className="mb-4 fw-bold">Contact Information</h4>
                
                <div className="contact-info-item">
                  <div className="icon-container bg-primary-light text-primary me-3">
                    <FiMail size={20} />
                  </div>
                  <div className="contact-info-content">
                    <h6 className="mb-1">Email</h6>
                    <p className="text-muted mb-0">
                      <a href="mailto:info@valuecraftminds.com" className="text-muted text-decoration-none hover-primary">
                        info@valuecraftminds.com
                      </a>
                      <br />
                      <a href="mailto:udara@valuecraftminds.com" className="text-muted text-decoration-none hover-primary">
                        udara@valuecraftminds.com
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="icon-container bg-success-light text-success me-3">
                    <FiPhone size={20} />
                  </div>
                  <div className="contact-info-content">
                    <h6 className="mb-1">Phone</h6>
                    <p className="text-muted mb-0">
                      <a href="tel:+94760200632" className="text-muted text-decoration-none hover-primary">
                        +94 77 361 2339
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="icon-container bg-info-light text-info me-3">
                    <FiMapPin size={20} />
                  </div>
                  <div className="contact-info-content">
                    <h6 className="mb-1">Location</h6>
                    <p className="text-muted mb-0">
                      No: 31A/52, Galwarusawa Road,<br />
                      Korathota, Kaduwela.
                    </p>
                  </div>
                </div>
                
                <hr className="my-4" />
                
                <h6 className="mb-3 fw-bold">Office Hours</h6>
                <p className="text-muted mb-0">
                  Monday - Friday: 9:00 AM - 6:00 PM<br />
                  Saturday - Sunday: Closed
                </p>
              </Card.Body>
            </Card>
          </Col>
          
          <Col lg={7}>
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                {status && (
                  <Alert 
                    variant={status} 
                    className="mb-4" 
                    onClose={() => setStatus(null)} 
                    dismissible
                  >
                    {alertMessage}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control 
                          type="text"
                          name="name"
                          required
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="John Doe"
                          disabled={isSubmitting}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control 
                          type="email"
                          name="email"
                          required
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="john@example.com"
                          disabled={isSubmitting}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control 
                      type="text"
                      name="subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="How can we help?"
                      disabled={isSubmitting}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4">
                    <Form.Label>Message</Form.Label>
                    <Form.Control 
                      as="textarea"
                      name="message"
                      rows={5}
                      required
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your audit needs..."
                      disabled={isSubmitting}
                    />
                  </Form.Group>
                  
                  <Button 
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="w-100 rounded-pill"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : (
                      <>
                        <FiSend className="me-2" />
                        Send Message
                      </>
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;